import React, {useState, useEffect} from 'react';
import dal from '../data/DAL';
import {Button, Icon, NavBar, TextareaItem, Toast, WhiteSpace, WingBlank} from "antd-mobile";
let debug = require('debug')('APP:AddQuestion')

const ReplyQuestion: React.FC = (props: any) => {
    const [content, setContent] = useState('');
    const [animating, setAnimating] = useState(false);

    const ticketId = props.location.state.ticketId;

    const addQuestion = () => {
        debug('输入内容为：', content);
        if (content === '') {
            Toast.fail('请输入内容');
            return;
        }
        setAnimating(true);
        dal.replyQuestion(ticketId, content).then(rsp => {
            setAnimating(false);
            if (rsp.data.status === 0) {
                Toast.success('回复成功',1);
                window.history.back();
            } else {
                Toast.fail(rsp.data.msg);
            }
        })
    }
    return (
        <div>
            <NavBar
                mode="light"
                //icon={<Link to={"/charge-plan"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}
                icon={<Icon color={'#666666'} size={'lg'} type="left"/>}
                onLeftClick={() => {
                    window.history.back()
                }}
                rightContent={[]}>
                回复：Raptor加速器
            </NavBar>
            <WhiteSpace size="xl"/>
            <WingBlank>
                <TextareaItem
                    placeholder={'请输入问题'}
                    rows={10}
                    labelNumber={5}
                    onChange={(text: any): void => {
                        setContent(text);
                    }}
                />
            </WingBlank>
            <div className={"sticky-footer"}>
                <div className="card-tile">
                    <div style={{flex: 1}}>
                        <Button type="ghost" disabled={animating} onClick={addQuestion}>发送</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ReplyQuestion